import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=e7bfc7c0&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports